import { MessageBox } from "element-ui";
import axios from "axios";
import Vue from "vue";
import Cookies from "js-cookie";
import router from "@/router";
// let isClient = process.env.VUE_ENV === 'client' //区分端

export default () => {
  // 设置请求api
  axios.defaults.baseURL = "https://cgzd.hejihua.com/api"
  // 超时时间
  axios.defaults.timeout = 20000;

  axios.interceptors.request.use((config) => {
    return new Promise((resolve, reject) => {
      // 添加token
      let token = Cookies.get("token");
      if (token) {
        config.headers.Authorization = "Bearer " + token;
      }
      resolve(config);
    });
  });

  axios.interceptors.response.use((res) => {
    return new Promise((resolve, reject) => {
      // 未设置状态码则默认成功状态
      const code = res.data.code || res.status || 10000;
      // 获取错误信息
      const msg = res.data.msg || res.data.message || res.message;
      if (code === 10009) {
        Cookies.remove("token");
        MessageBox.alert("您的登录信息已失效，请重新登录", "系统提示", {
          confirmButtonText: "重新登录",
          callback: () => {
            // app.router.push('/login')
            router.replace({
              path: "/login",
            });
            // redirect("/login");
          },
        });
        // reject('令牌验证失败')
        reject(res.data);
      } else if (
        code === 110059 ||
        code === 10023 ||
        code === 10008 ||
        code === 110062 ||
        code === 110063
      ) {
        // 用户未注册  或 微信扫码未绑定手机号
        reject(res.data);
      } else if (code === 500 || code === 99999) {
        // Message.error(msg)
        reject(msg);
      } else if (code !== 10000 && code !== "0") {
        // Message.error(msg)
        reject("error");
      } else {
        // 返回数据
        resolve(res.data?.data);
      }
    });
  });
  axios.$get = axios.get;
  axios.$post = axios.post;
  axios.$delete = axios.delete;
  axios.$put = axios.put;
  Vue.prototype.$axios = axios;
  Vue.prototype.$cookies = Cookies;
};
